import React from 'react';
import { useLocation } from 'react-router-dom';

const Looker = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const embedUrl = queryParams.get('url'); // Extract the URL part after "https://lookerstudio.google.com/embed/"

  // Reconstruct the full URL
  const fullUrl = embedUrl ? `https://lookerstudio.google.com/embed/${embedUrl}` : null;

  return (
    <div>
      {fullUrl ? (
        <iframe
          width="100%"
          height="800"
          src={fullUrl}
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      ) : (
        <p>No URL provided for the dashboard.</p>
      )}
    </div>
  );
};

export default Looker;